import { render, staticRenderFns } from "./gdt.vue?vue&type=template&id=7a8bc208&scoped=true"
import script from "./gdt.vue?vue&type=script&lang=js"
export * from "./gdt.vue?vue&type=script&lang=js"
import style0 from "./gdt.vue?vue&type=style&index=0&id=7a8bc208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8bc208",
  null
  
)

export default component.exports